<script setup>
defineProps({
  active: { type: String, default: '' },
  items: { type: Array, default: () => [] },
  labelFor: { type: Function, required: true },
});

const emit = defineEmits(['select']);
</script>

<template>
  <div class="flex flex-wrap gap-2" role="tablist">
    <button
      v-for="item in items"
      :key="item.value || 'vgv'"
      type="button"
      role="tab"
      :aria-selected="active === item.value"
      class="rounded-full border px-3 py-2 text-sm font-semibold transition"
      :class="
        active === item.value
          ? 'border-lais-primary bg-lais-primary text-white'
          : 'border-lais-border bg-white text-lais-text hover:border-lais-primary'
      "
      @click="emit('select', item.value)"
    >
      {{ labelFor(item) }}
    </button>
  </div>
</template>
